import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCancelDeskCheckinMutation = () =>
  useTypedMutation<number | null, boolean>({
    mutationFn: async desk_communication_id => {
      if (!desk_communication_id) throw new Error("No desk communication found");

      await ApiInstance.post("/receptionists/cancel", { desk_communication_id }, ENV.deskBaseURL);
      return true;
    },
    onSuccess: (_payload, isCanceledOnBackend) => {
      if (isCanceledOnBackend) typedQueryClient.invalidateQueries(AppointmentDetailsKeys.view);
    }
  });
